import React from "react";

const BillingTotalShow = ({ totals }) => {
  const formatter = new Intl.NumberFormat("es-CO", {
    style: "currency",
    currency: "COP",
    minimumFractionDigits: 0
  });

  return (
    <div className="HContainer shadow-md j-center a-center mt-15">
      <p className="totalText">Total: {"  "}</p>{" "}
      <span className="totalValueText">{formatter.format(totals || 0)}</span>
    </div>
  );
};

export default BillingTotalShow;
